import React__default from 'react';
import { useNonNullishContext } from '../../../hooks/use-non-nullish-context.js';
/**
 * This context/provider is to lift the react-aria <Item> state up the react tree for combobox and listbox components
 *
 * For internal use only.
 */

var SwanCollectionContext = /*#__PURE__*/React__default.createContext(undefined);

function useCollectionContext() {
  return useNonNullishContext(SwanCollectionContext);
}

export { SwanCollectionContext, useCollectionContext };